export const noteSections = [
  "subjective",
  "objective",
  "assessment",
  "plan",
  "additionalNotes",
  "clientSummary",
];
